export default {
  UPLOADING: 'UPLOADING',
  PROCESSING: 'PROCESSING',
  FAILED: 'FAILED',
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR',
};
